var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-logo pb-10"},[_c('h1',{staticClass:"pb-3"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('h6',{class:[_vm.hasError ? 'error-msg' : '']},[_vm._v(" "+_vm._s(_vm.hasError ? _vm.errorMessage : _vm.subheader)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }